import { VeiculoAPI } from '@/api/sit-pedidos/veiculo.api'
import { AxiosObservable } from 'axios-observable'
import { map } from 'rxjs/operators'
import { Veiculo } from '@/models/veiculo'
import { TipoVeiculo } from '@/models/tipo_veiculo'
import Cor from '@/models/cor'
import Combustivel from '@/models/combustivel'
import MarcaModelo from '@/models/marcaModelo'
import { Observable } from 'rxjs'
import { VeiculoInclusaoPayload } from '@/models/sit-pedido/veiculo-inclusa'
import MarcaChassi from '@/models/marcaChassi'
import Uf from '@/models/uf'

const api = new VeiculoAPI()

const getTipoServicoTransportadora = (transporadoraId: number): AxiosObservable<any> => api.getTipoServicoTransportadora(transporadoraId)

const getTipoVeiculo = (): AxiosObservable<any> => api.getTipoVeiculo()

const getAreasAtuacaoTransportadora = (transporadoraId: number): AxiosObservable<any> => api.getAreasAtuacaoTransportadora(transporadoraId)

const getCooperadosTransportadora = (transporadoraId: number): AxiosObservable<any> => api.getCooperadosTransportadora(transporadoraId)

const getDadosVeiculo = (placa: string): Observable<VeiculoInclusaoPayload> => {
  return api.getDadosVeiculo(placa).pipe(map(({veiculoPedido}: any)=>{
    const tipoVeiculo = new TipoVeiculo(Number(veiculoPedido.tipoVeiculo.id), null, veiculoPedido.tipoVeiculo.descricao, null, null, null, null)
    const corVeiculo = new Cor(Number(veiculoPedido.cor.id), veiculoPedido.cor.nome, null, null, null, null)
    const combustivelVeiculo = new Combustivel(Number(veiculoPedido.combustivel.id), veiculoPedido.combustivel.nome, null, null, null, null)
    const marcaModeloVeiculo = new MarcaModelo(Number(veiculoPedido.marcaModelo.id), veiculoPedido.marcaModelo.nome, null, null, null)
    const marcaChassiVeiculo = new MarcaChassi(null, null, null, null, null)
    const uf =  new Uf(Number(veiculoPedido.ufJurisdicao.id), veiculoPedido.ufJurisdicao.nome, veiculoPedido.ufJurisdicao.sigla)


    return new VeiculoInclusaoPayload(
      veiculoPedido.placa,
      veiculoPedido.chassiNumero,
      veiculoPedido.potencia,
      veiculoPedido.lotacaoSentados,
      null,
      false,
      false,
      false,
      false,
      veiculoPedido.renavam,
      veiculoPedido.chassiAno,
      null,
      veiculoPedido.ultAnoLicenciamento,
      null, // tipoVeiculo
      corVeiculo,
      combustivelVeiculo,
      veiculoPedido.anoFabricacao,
      marcaChassiVeiculo,
      marcaModeloVeiculo,
      uf
    )
  }))
}

const getRegioesMetropolitanas = (): AxiosObservable<any> => api.getRegioesMetropolitanas()

export default {
  getTipoServicoTransportadora,
  getTipoVeiculo,
  getAreasAtuacaoTransportadora,
  getCooperadosTransportadora,
  getDadosVeiculo,
  getRegioesMetropolitanas
}
